import { render } from "./NewParametersCard.vue?vue&type=template&id=44649a70&scoped=true"
import script from "./NewParametersCard.vue?vue&type=script&lang=js"
export * from "./NewParametersCard.vue?vue&type=script&lang=js"

import "./NewParametersCard.vue?vue&type=style&index=0&id=44649a70&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44649a70"]])

export default __exports__